module.exports = __webpack_public_path__ + "static/img/kwh_content_bg3.91e839e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_content_bg3.png
// module id = 87a1
// module chunks = 1